import { useState, useEffect, useContext } from "react";
// @mui material components
import Card from "@mui/material/Card";
import { Icon } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Switch from "@mui/material/Switch";
import MDInput from "components/MDInput";
import AccountingApi from "../../../../Classes/API/AccountingApi";
import CreateAccountingEntryReq from "../../../../Classes/Models/Requests/Accounting/CreateAccountingEntryReq";
import Swal from "sweetalert2";
import { UserContext } from "App";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "App";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import ServicesApi from "../../../../Classes/API/Services/ServicesApi";

import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import RefundReq from "../../../../Classes/Models/Requests/Accounting/RefundReq";
import MDButton from "components/MDButton";
import "./pacakge.scss";
import PayFromBalanceReq from "Classes/Models/Requests/Accounting/PayFromBalanceReq";
import TransferToUserBalanceReq from "../../../../Classes/Models/Requests/Accounting/TransferToUserBalanceReq";
import {
  PaidOutlined,
  PersonPinCircle,
  PersonPinCircleRounded,
} from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const PackageDetailsCard = ({
  Package,
  setShowSessions,
  ShowSessions,
  setIsLoaded,
  setShowAddSessions,
  ShowAddSessions,
  userBalance,
}) => {
  const navigate = useNavigate();
  const CurrentUser = useContext(UserContext);
  const [AmountToPay, setAmountToPay] = useState(0);
  const { translations } = useContext(LanguageContext);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [serviceAmountDue, setServiceAmountDue] = useState("");

  const [loadingLastBundle, setLoadingLastBundle] = useState(true);
  const [isPayFromBalance, setIsPayFromBalance] = useState(false);
  const [recentBundle, setRecentBundle] = useState(null);
  const [unlinkedBundles, setUnlinkedBundles] = useState([]);
  const [openUnlinkedBundlesModal, setOpenUnlinkedBundlesModal] =
    useState(false);

  const fetchLastBundle = async () => {
    const patientId = Package?.getPatient?.id;
    const packageId = Package?.id;
    if (!patientId) {
      setLoadingLastBundle(false);
      return;
    }

    try {
      setLoadingLastBundle(true);
      const res = await ServicesApi.LastServiceBundle(patientId, packageId);
      if (res.status === "Success" && res.data) {
        const bundleDate = new Date(
          res.data.serviceBundle.startDate || res.data.serviceBundle.createdAt,
        );
        setServiceAmountDue(res.data.amountDue);
        const threeMonthsAgo = new Date().setMonth(new Date().getMonth() - 3);

        if (
          res.data.serviceBundle.id === Package.id ||
          bundleDate < threeMonthsAgo
        ) {
          setRecentBundle(null);
        } else {
          setRecentBundle(res.data.serviceBundle);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingLastBundle(false);
    }
  };

  useEffect(() => {
    fetchLastBundle();
    fetchUnlinkedBundles();
  }, [Package]);

  const fetchUnlinkedBundles = async () => {
    const patientId = Package?.patientId || Package?.getPatient?.id;
    if (!patientId) return;

    const res = await ServicesApi.GetUnlinkedBundles(patientId);
    if (res.status === "Success") {
      setUnlinkedBundles(res.data);
    }
  };

  const linkBundle = async (bundleId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to link this bundle to this package?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, link it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await ServicesApi.LinkBundleToPackage({
          bundleId: bundleId,
          packageId: Package.id,
        });
        if (res.status === "Success") {
          Swal.fire("Success", "Bundle linked successfully", "success");
          fetchUnlinkedBundles();
          setIsLoaded(false);
        } else {
          Swal.fire("Error", res.message, "error");
        }
      }
    });
  };

  const PayAmount = async () => {
    if (!paymentMethod) {
      Swal.fire({
        title: "Error",
        text: "Please enter a Payment Method",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    const req = new CreateAccountingEntryReq();
    req.Amount = AmountToPay;
    req.Description = "Payment for Package " + Package.packageName;
    req.isProfit = true;
    req.packageId = Package.id;
    req.title = "Payment for Package " + Package.packageName;
    req.entryType = "Package";
    req.creatorId = CurrentUser.id;
    req.paymentMethod = paymentMethod;
    const res = await AccountingApi.CreateAccountingEntry(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const payAmountFromUserBalance = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    const req = new PayFromBalanceReq();
    req.amountToPay = AmountToPay;
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    req.creatorId = CurrentUser.id;
    const res = await AccountingApi.PayFromUserBalanceForPackage(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: res.message || "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const transferAvailableBalance = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    const req = new PayFromBalanceReq();
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    const res = await AccountingApi.transferAvailableAmount(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const transferRefundableAmount = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    const req = new PayFromBalanceReq();
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    const res = await AccountingApi.transferRefundableAmount(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const refundRefundableAmount = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    let req = new TransferToUserBalanceReq();
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    let res = await AccountingApi.refundRefundableAmount(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Refund successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Refund failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const refundAvailableAmount = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    let req = new TransferToUserBalanceReq();
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    let res = await AccountingApi.refundAvailableAmount(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Refund successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Refund failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const RefundPackage = async () => {
    const refReq = new RefundReq();
    refReq.packageId = Package.id;
    refReq.creatorId = CurrentUser.id;
    refReq.refundType = "Package";
    const res = await AccountingApi.Refund(refReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Refund successful",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Refund failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const DeletePackage = async () => {
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmation.value) {
      return;
    }

    const req = new SearchStringOrIntReq();
    req.SearchInt = Package.id;

    const res = await SessionsApi.DeletePackage(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Package deleted",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        navigate("/Accountingsessions");
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Package deletion failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleDownload = async () => {
    try {
      const blob = await AccountingApi.PrintPackageSummary(Package.id);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `Package_${Package.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading receipt:", error);
    }
  };

  const ExportReport = async () => {
    try {
      Swal.fire({
        title: "Exporting Excel",
        text: "Please wait while we generate your spreadsheet",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      const req = { searchInt: Package.id };
      const response = await AccountingApi.ExportPackageReport(req);
      let blob;
      if (response instanceof Blob) {
        blob = response;
      } else if (response?.data) {
        const byteData = Array.isArray(response.data)
          ? new Uint8Array(response.data)
          : response.data;
        blob = new Blob([byteData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const tempLink = document.createElement("a");
        tempLink.href = url;

        tempLink.setAttribute("download", `PackageReport_${Package.id}.xlsx`);

        document.body.appendChild(tempLink);
        tempLink.click();

        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);

        Swal.close();
      } else {
        throw new Error("No data received from server");
      }
    } catch (error) {
      console.error("Error exporting report:", error);
      Swal.fire({
        title: "Export Failed",
        text: "Failed to export Excel report.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const GetAmountAvailable = () => {
    let totalPaid = 0;
    Package.getAccountingSessions?.map((AccSession) => {
      totalPaid += AccSession.isPaidFor ? AccSession.finalPrice : 0;
    });

    let totalServicesPaid = 0;
    if (Package.serviceBundles) {
      Package.serviceBundles.forEach((bundle) => {
        if (bundle.bundleItems) {
          bundle.bundleItems.forEach((item) => {
            if (item.isPaid || item.status === 2 || item.status === "Done") {
              totalServicesPaid += item.priceAtTime;
            }
          });
        }
      });
    }

    return (Package.amountPaid ?? 0) - (totalPaid + totalServicesPaid);
  };

  const TogglePostPaid = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    const req = new SearchStringOrIntReq();
    req.SearchInt = Package.id;

    const res = await AccountingApi.TogglePackagePostPaid(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Package updated",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Package update failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  return (
    <Card
      sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em" }}
    >
      <MDBox
        pt={2}
        px={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MDTypography variant="h6" fontWeight="medium">
          {translations.PackageInfoPackageInfo}
        </MDTypography>
        <div style={{ display: "flex", gap: "1rem" }}>
          <MDButton
            onClick={() => DeletePackage()}
            variant="gradient"
            color="dark"
          >
            <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
            &nbsp;{translations.PackageInfoDeletepackage}
          </MDButton>
          <MDButton
            onClick={() => handleDownload()}
            variant="gradient"
            color="light"
          >
            <Icon sx={{ fontWeight: "bold" }}>summarize</Icon>
            &nbsp;{translations.PackageInfoPackageSummary}
          </MDButton>

          {unlinkedBundles.length > 0 && (
            <MDButton
              onClick={() => setOpenUnlinkedBundlesModal(true)}
              variant="gradient"
              color="info"
            >
              <Icon sx={{ fontWeight: "bold" }}>link</Icon>
              &nbsp;Link Bundle ({unlinkedBundles.length})
            </MDButton>
          )}

          <MDButton
            onClick={() => ExportReport()}
            variant="gradient"
            color="success"
          >
            &nbsp;{translations.PackageInfoExportReport}
          </MDButton>
        </div>
      </MDBox>

      {recentBundle && (
        <MDBox
          mx={2}
          my={2}
          p={1}
          sx={{
            backgroundColor: "#e1f5fe",
            border: "1px solid #2196f3",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={() =>
            navigate(`/ViewServiceBundles/BundleDetails/${recentBundle.id}`)
          }
        >
          <MDTypography
            variant="button"
            color="info"
            fontWeight="medium"
            display="flex"
            alignItems="center"
          >
            <Icon sx={{ mr: 1 }}>info</Icon>
            Patient had a service bundle in the last 3 months. Click here to go
            to the service bundle.
          </MDTypography>
        </MDBox>
      )}

      <div className="grid-container">
        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoName}: &nbsp;
          </MDTypography>
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {Package.getPatient.getUser.name}
          </MDTypography>
        </div>
        <div className="child-grid">
          <MDBox>
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.PackageInfoPackageId}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Package.id}
            </MDTypography>
          </MDBox>
        </div>
        <div className="child-grid">
          <MDBox>
            {Package.isPaidFor ? (
              <>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {" "}
                  {translations.PackageInfoStatus}{" "}
                </MDTypography>{" "}
                :{" "}
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="success"
                >
                  {translations.PackageInfoPaid}
                </MDTypography>
              </>
            ) : (
              <>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {" "}
                  {translations.PackageInfoStatus}{" "}
                </MDTypography>{" "}
                :{" "}
                <MDTypography variant="button" fontWeight="regular" color="red">
                  {translations.PackageInfoNotPaid}
                </MDTypography>
              </>
            )}
          </MDBox>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoOriginalPrice}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.originalPrice}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoDiscount}
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Number(Package.discount).toFixed(1)}%
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoFinalPrice}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.finalPrice}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoCreatedAt}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.timeStamp.split("T")[0]}
          </MDTypography>
        </div>
      </div>
      <hr
        style={{
          margin: "20px 0",
          border: "none",
          borderTop: "1px solid #ccc",
        }}
      />
      <div className="grid-container">
        <div className="child-grid">
          {loadingLastBundle ? (
            <MDTypography variant="button" fontWeight="regular" color="text">
              Loading...
            </MDTypography>
          ) : (
            <>
              <MDTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                {translations.PackageInfoAmountRemaining}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Package.amountDue + serviceAmountDue}
              </MDTypography>
            </>
          )}
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoAmountDiscounted}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.discountedAmount}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoDiscountedAmountUsed}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.discountedAmountUsed}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoRefundableAmount}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular">
            &nbsp;{Package.refundableAmount}
          </MDTypography>
        </div>
        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoAmountPaid} (
            {translations.PackageInfoPackageBalance}): &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.amountPaid}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoAmountUsed} (
            {translations.PackageInfoAdmitted}): &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.amountUsed}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoAmountAvailable} (
            {translations.PackageInfoFromPackageBalance}) : &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;
            {GetAmountAvailable()}
          </MDTypography>
        </div>
      </div>

      <div>
        {/* Transfer buttons row */}
        <div
          style={{
            marginTop: "2px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "10px",
            flexWrap: "wrap",
            marginBottom: "10px",
            paddingLeft: "25px",
            width: "80%",
          }}
        >
          <button
            className="btn btn-primary"
            onClick={transferRefundableAmount}
          >
            {translations.TransferPackageInfoRefundableAmount}
          </button>
          <button
            className="btn btn-primary"
            onClick={transferAvailableBalance}
          >
            {translations.TransferPackageInfoAmountAvailable}
          </button>
        </div>
        {/* Refund buttons row */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "10px",
            flexWrap: "wrap",
            paddingLeft: "25px",
            marginBottom: "30px",
          }}
        >
          <button className="btn btn-warning" onClick={refundRefundableAmount}>
            Refund (Refundable Amount)
          </button>
          <button className="btn btn-warning" onClick={refundAvailableAmount}>
            Refund (Full Amount)
          </button>
        </div>
      </div>
      <hr
        style={{
          margin: "20px 0",
          border: "none",
          borderTop: "1px solid #ccc",
        }}
      />
      <div
        className="grid-container"
        style={{ display: "flex", flexDirection: "column", gap: "10px" }}
      >
        <div
          className="child-grid"
          style={{ display: "flex", alignItems: "center" }}
        >
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoShowSessions}: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch
              checked={ShowSessions}
              onChange={() => setShowSessions(!ShowSessions)}
            />
          </MDBox>
        </div>

        <div
          className="child-grid"
          style={{ display: "flex", alignItems: "center" }}
        >
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoAddSessions}: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch
              checked={ShowAddSessions}
              onChange={() => setShowAddSessions(!ShowAddSessions)}
            />
          </MDBox>
        </div>

        <div
          className="child-grid"
          style={{ display: "flex", alignItems: "center" }}
        >
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {translations.PackageInfoPostPaid}
          </MDTypography>
          <MDBox>
            <Switch
              checked={Package.postPaid}
              onChange={() => {
                TogglePostPaid();
              }}
            />
          </MDBox>
        </div>
      </div>

      <div style={{ paddingLeft: "20px" }}>
        <div
          className="child-grid"
          style={{ display: "flex", alignItems: "center" }}
        >
          <MDTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            Pay From User Balance: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch
              checked={isPayFromBalance}
              onChange={() => setIsPayFromBalance(!isPayFromBalance)}
            />
          </MDBox>
        </div>
      </div>

      <Dialog
        open={openUnlinkedBundlesModal}
        onClose={() => setOpenUnlinkedBundlesModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Unlinked Service Bundles</DialogTitle>
        <DialogContent>
          <MDBox pt={2}>
            {unlinkedBundles.map((bundle) => (
              <MDBox
                key={bundle.id}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
                p={2}
                sx={{ border: "1px solid #eee", borderRadius: "8px" }}
              >
                <MDBox>
                  <MDTypography
                    variant="button"
                    fontWeight="bold"
                    display="block"
                  >
                    Bundle #{bundle.id}
                  </MDTypography>
                  <MDTypography variant="caption" color="text">
                    {bundle.itemsCount} Items • Created:{" "}
                    {new Date(bundle.createdAt).toLocaleDateString()}
                  </MDTypography>
                </MDBox>
                <MDButton
                  variant="gradient"
                  color="info"
                  size="small"
                  onClick={() => {
                    linkBundle(bundle.id);
                    setOpenUnlinkedBundlesModal(false);
                  }}
                >
                  Link to Package
                </MDButton>
              </MDBox>
            ))}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => setOpenUnlinkedBundlesModal(false)}
            color="secondary"
          >
            Close
          </MDButton>
        </DialogActions>
      </Dialog>

      <div className="pay-amount-container">
        {isPayFromBalance && (
          <p style={{ color: "green", textAlign: "left" }}>
            <PersonPinCircleRounded /> {translations.userBalance}: {userBalance}
            $
          </p>
        )}
        <div className="pay-details">
          <div className="info-labels">
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {translations.PackageInfoPayAmount}:
            </MDTypography>
          </div>

          <MDInput
            type="number"
            variant="standard"
            value={AmountToPay}
            onChange={(e) => setAmountToPay(e.target.value)}
            className="amount-input"
          />
        </div>

        <div className="payment-method-container">
          {!isPayFromBalance && (
            <select
              value={paymentMethod}
              onChange={handleChange}
              className="payment-selector"
            >
              <option value="" disabled>
                {translations.SelectPaymentmethod}
              </option>
              <option value="Visa">
                {translations.SelectPaymentmethodvisa}
              </option>
              <option value="Cash">
                {translations.SelectPaymentmethodCash}
              </option>
              <option value="Bank-transfer">
                {translations.SelectPaymentmethodBankTransfer}
              </option>
            </select>
          )}
          {!isPayFromBalance && (
            <button
              className="btn btn-primary"
              onClick={PayAmount}
              disabled={!paymentMethod}
            >
              {translations.PackageInfoPay}
            </button>
          )}
          {isPayFromBalance && (
            <button
              className="btn btn-primary"
              onClick={payAmountFromUserBalance}
            >
              {translations.PackageInfoPayUserBalance}
            </button>
          )}

          {/* <GenerateReceiptButton className="pay-btn" Package={Package} ReceiptType="Package" /> */}
        </div>
      </div>

      <div className="refund-btn">
        <button
          className="btn  btn-danger"
          onClick={() => {
            RefundPackage();
          }}
        >
          {translations.PackageInfoRefundPackage}
        </button>
      </div>
    </Card>
  );
};

export default PackageDetailsCard;
